import { render } from "./IconSwarm.vue?vue&type=template&id=9cca56aa"
const script = {}

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__